import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addWasteCollectionArea = (wasteCollectionArea) => {
  const promises = [];
  return http
    .post("/waste-collection/create", {
      areaName: wasteCollectionArea.areaName,
      areaLocation: wasteCollectionArea.areaLocation,
      cityId: wasteCollectionArea.cityId,
      userId: wasteCollectionArea.userId,
      dumpyardId: wasteCollectionArea.dumpyardId,
      segregationId: wasteCollectionArea.segregationId,
      transportId: wasteCollectionArea.transportId,
      wasteAreaGeoLocation: wasteCollectionArea.wasteAreaGeoLocation,
    })
    .then((result) => {
      wasteCollectionArea = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.updateWasteCollectionArea = (wasteCollectionArea) => {
  const promises = [];
  return http
    .put("/waste-collection/update", {
      areaName: wasteCollectionArea.areaName,
      areaLocation: wasteCollectionArea.areaLocation,
      cityId: wasteCollectionArea.cityId,
      userId: wasteCollectionArea.userId,
      dumpyardId: wasteCollectionArea.dumpyardId,
      segregationId: wasteCollectionArea.segregationId,
      transportId: wasteCollectionArea.transportId,
      status: wasteCollectionArea.status,
      wasteAreaGeoLocation: wasteCollectionArea.wasteAreaGeoLocation,
      _id: wasteCollectionArea._id,
    })
    .then((result) => {
      wasteCollectionArea = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getwasteCollection = (Id) => {
  return http
    .get(`/waste-collectionbyId?id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getCollectionDivisionList = (Id) => {
  return http
    .get(`/division-waste-collection/byId?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getCollectionDivisionById = (Id) => {
  return http
    .get(`/division-waste-collection-byId?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("authService.getUser-error:\n", error);
      throw error;
    });
};

internals.getSurveyoysList = (Id) => {
  return http
    .get(`/register/surveyor/list`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.addcollectionDivision = (collectionDivision) => {
  const promises = [];
  return http
    .post("/division-waste-collection/create", {
      caId: collectionDivision.caId,
      cdName: collectionDivision.cdName,
      cdaName: collectionDivision.cdaName,
      lineTowerHouse: collectionDivision.lineTowerHouse,
      // surveyorId: collectionDivision.surveyorId,
      userId: collectionDivision.userId,
      cityId: collectionDivision.cityId,
    })
    .then((result) => {
      collectionDivision = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.updatecollectionDivision = (collectionDivision) => {
  // wasteCollectionArea = Object.assign({}, wasteCollectionArea)
  const promises = [];
  return http
    .put("/division-waste-collection/update", {
      caId: collectionDivision.caId,
      cdName: collectionDivision.cdName,
      cdaName: collectionDivision.cdaName,
      lineTowerHouse: collectionDivision.lineTowerHouse,

      userId: collectionDivision.userId,
      cityId: collectionDivision.cityId,
      _id: collectionDivision._id,
    })
    .then((result) => {
      collectionDivision = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.wasteCollectionsearch = function(params, searchItem) {
  return http
    .get(
      `/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.updateCDName = (collectionDivision) => {
  const promises = [];
  return http
    .put("/division-name/update", {
      name: collectionDivision.name,
      _id: collectionDivision._id,
    })
    .then((result) => {
      collectionDivision = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("CollectionDivisionService-error:\n", error);
      throw error;
    });
};

internals.deleteLine = (_id) => {
  return http
    .delete(`/line-house-tower/delete?_id=` + _id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("Line.delete-error:\n", error);
      throw error;
    });
};

internals.addLine = (line) => {
  // wasteCollectionArea = Object.assign({}, wasteCollectionArea)
  const promises = [];
  return http
    .post("/line-house-tower/create", {
      cdId: line.cdId,
      name: line.name,
      houses: line.houses,
    })
    .then((result) => {
      line = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.updateLine = (line) => {
  // wasteCollectionArea = Object.assign({}, wasteCollectionArea)
  const promises = [];
  return http
    .put("/division-waste-collection/update", {
      cdId: line.cdId,
      name: line.name,
      houses: line.houses,
      userId: line.userId,
      _id: line._id,
    })
    .then((result) => {
      line = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getWasteArea = function() {
  return http
    .get(
      `/waste-collection?page=1&limit=999`
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};


internals.getcollectionDivisionsByAreaId = (wasteCollectionArea) => {
  const promises = [];
  return http
    .post("/division-waste-collection/byIds", {
      wcaIds: wasteCollectionArea,
    })
    .then((result) => {
      return result 
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getAllHousesByWCId = function(id) {
  return http
    .get(
      `/house/by-waste-collection-area-id?_id=${id} `
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("wasteCollectionService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.getCSV = async (data) => {
  try {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString().replace(/[,/]/g, "-");

    const response = await http.get(`/trip/csv/download?type=${data.type}&cityId=${data.cityId}&wardIds=${data.wardIds}`);
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${data.type}_${formattedDate}.csv`);
    document.body.appendChild(link);
    link.click();

    return response.data; 
  } catch (error) {
    console.error('CSV Download Error:', error);
    throw error; 
  }
};

internals.addKmlFile = (id,data) => {
  const promises = [];
  return http
    .put(`/ward-collection-area-file-upload?_id=${id}`, data)
    .then((result) => {
      result = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.deleteKmlFile = (id) => {
  const promises = [];
  return http
    .delete(`/ward-collection-area-file-upload?_id=${id}`)
    .then((result) => {
      result = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getKmlById = (id) =>{
  return http
    .get(`/ward-collection-area-file-upload?_id=${id} `)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("wasteCollectionService.inviteUser-error:\n", error);
      throw error;
    });
};




export default internals;



// WEBPACK FOOTER //
// ./src/services/wasteCollectionArea.service.js